const keys = {
	USER: "users",
	ORDER: "orders",
};

export default keys;
